<template>
  <div class="pagination__wrapper" :class="rootCss">
    <h4 class="pagination__subtitle_counter">
      Количество страниц: {{ pagesCounter }}
    </h4>
    <ul class="pagination pagination-lg">
      <li
        v-if="paginationRange.length > 0"
        class="page-item pagination__item pagination__icon"
      >
        <a
          class="page-link"
          :class="leftArrowCss"
          @click.prevent="handleClick(currentPage - 1)"
        >
          <i class="fa fa-angle-left" />
        </a>
      </li>
      <li
        v-for="(number, index) in paginationRange"
        :key="index"
        class="page-item pagination__item"
      >
        <a
          class="page-link"
          :class="getLinkCss(number)"
          @click.prevent="handleClick(number)"
        >
          {{ number }}
        </a>
      </li>
      <li
        v-if="paginationRange.length > 0"
        class="page-item pagination__item pagination__icon"
      >
        <a
          class="page-link"
          :class="rightArrowCss"
          @click.prevent="handleClick(currentPage + 1)"
        >
          <i class="fa fa-angle-right" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { pagination } from "@/_shared/utils";
const DOTS = "...";
export default {
  props: {
    siblingCount: {
      type: Number,
      default: 1,
    },
    pagesCounter: {
      type: Number,
      default: 1,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    leftArrowCss() {
      if (this.currentPage === 1) {
        return ["pagination_disabled"];
      }
    },
    rightArrowCss() {
      if (this.currentPage === this.pagesCounter) {
        return ["pagination_disabled"];
      }
    },
    rootCss() {
      return {
        pagination_disabled: this.disabled,
      };
    },
    paginationRange() {
      const totalPageNumbers = this.siblingCount + 5;
      if (totalPageNumbers >= this.pagesCounter) {
        return pagination.getRange(1, this.pagesCounter);
      }

      const leftSiblingIndex = Math.max(
        this.currentPage - this.siblingCount,
        1
      );
      const rightSiblingIndex = Math.min(
        this.currentPage + this.siblingCount,
        this.pagesCounter
      );
      const shouldShowLeftDots = leftSiblingIndex > 2;
      const shouldShowRightDots = rightSiblingIndex < this.pagesCounter - 2;
      if (!shouldShowLeftDots && shouldShowRightDots) {
        let leftItemCount = 3 + 2 * this.siblingCount;
        let leftRange = pagination.getRange(1, leftItemCount);
        return [...leftRange, DOTS, this.pagesCounter];
      }

      const firstPageIndex = 1;
      if (shouldShowLeftDots && !shouldShowRightDots) {
        let rightItemCount = 3 + 2 * this.siblingCount;
        let rightRange = pagination.getRange(
          this.pagesCounter - rightItemCount + 1,
          this.pagesCounter
        );
        return [firstPageIndex, DOTS, ...rightRange];
      }

      const lastPageIndex = this.pagesCounter;
      if (shouldShowLeftDots && shouldShowRightDots) {
        const middleRange = pagination.getRange(
          leftSiblingIndex,
          rightSiblingIndex
        );
        return [firstPageIndex, DOTS, ...middleRange, DOTS, lastPageIndex];
      }
    },
  },
  methods: {
    getLinkCss(pageNumber) {
      const disablingValues = [this.currentPage, "..."];
      const selectedValues = [this.currentPage, this.pagesCounter, 1];
      const desktopDevicesOnly = [1, this.pagesCounter];
      return {
        "page-link_disabled": !!disablingValues.includes(pageNumber),
        "page-link_unselected": !selectedValues.includes(pageNumber),
        "page-link_desktop-only":
          desktopDevicesOnly.includes(pageNumber) &&
          this.currentPage !== pageNumber,
      };
    },
    handleClick(clickedNumber) {
      this.$emit("select", clickedNumber);
    },
  },
};
</script>

<style scoped>
.page-link_disabled {
  opacity: 0.4;
  pointer-events: none;
}

.pagination__wrapper {
  display: flex;
  flex-direction: row;
  column-gap: 1em;
  align-items: center;
}

.pagination__item:focus,
.pagination__item:hover {
  cursor: pointer;
}

.pagination__subtitle_counter {
  display: none;
}

.pagination_disabled {
  transition: opacity 0.3s;
  opacity: 0.5;
  pointer-events: none;
}

@media (max-width: 1023px) {
  .page-link_unselected {
    display: none;
  }
  .pagination__wrapper {
    justify-content: center;
  }
}
@media (max-width: 419px) {
  .pagination__wrapper {
    display: flex;
    flex-direction: column;
  }
  .pagination__subtitle_counter {
    text-align: center;
    display: inline-block;
  }
  .page-link_desktop-only {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/_shared/components/ui/Pagination.vue